/**
 * useGalleryBlockEditor — `vm` + `actions` do editor do bloco Galeria (contrato `galleryBlock.vm.js` @v1) e da
 * biblioteca de imagens que ele abre (contrato `mediaLibrary.vm.js` @v1, modo 'gallery').
 * docs/PLANO-EXECUCAO-MIDIA.md TODO 7.3 — o container só renderiza as duas Views com o que este hook devolve:
 *
 *   const { vm, actions, library } = useGalleryBlockEditor({ value, onChange });
 *   return <><GalleryBlockView vm={vm} actions={actions} /><MediaLibrary vm={library.vm} actions={library.actions} /></>;
 *
 * As operações no `config` são puras (`galleryBlockModel.js`); `value`/`onChange` são os do registro de blocos
 * (`BlockList` passa o `config` do bloco e recebe o novo).
 */
import { useCallback, useMemo, useState } from 'react';
import useMediaLibrary from '../../media/useMediaLibrary';
import useContaDoEditor from '../../media/useContaDoEditor';
import {
  montarVm, adicionar, legenda, descricao, remover, mover, reordenar, trocarLayout, jaNaGaleria, vagas,
} from './galleryBlockModel.js';

export default function useGalleryBlockEditor({ value, onChange }) {
  const { donoId, nomeDoRamo } = useContaDoEditor();
  const [bibliotecaAberta, setBibliotecaAberta] = useState(false);
  const fechar = useCallback(() => setBibliotecaAberta(false), []);

  const naGaleria = useMemo(() => jaNaGaleria(value), [value]);
  const library = useMediaLibrary({
    open: bibliotecaAberta,
    mode: 'gallery',
    jaNaGaleria: naGaleria,
    vagas: vagas(value),
    nomeDoRamo,
    onConfirm: (fotos) => { onChange(adicionar(value, fotos)); setBibliotecaAberta(false); },
    onClose: fechar,
  });

  const vm = useMemo(() => montarVm(value, donoId), [value, donoId]);
  const actions = useMemo(() => ({
    onAddPhotos: () => setBibliotecaAberta(true),
    onChangeLayout: (v) => onChange(trocarLayout(value, v)),
    onChangeCaption: (key, texto) => onChange(legenda(value, key, texto)),
    onChangeAlt: (key, texto) => onChange(descricao(value, key, texto)),
    onMoveUp: (key) => onChange(mover(value, key, -1)),
    onMoveDown: (key) => onChange(mover(value, key, 1)),
    onReorder: (de, para) => onChange(reordenar(value, de, para)),
    onRemove: (key) => onChange(remover(value, key)),
  }), [value, onChange]);

  return { vm, actions, library };
}
